import { useState, useEffect } from 'react';
import { db } from '../utils/Database';

const useBackupAlert = () => {
    const [shouldShowAlert, setShouldShowAlert] = useState(false);
    const [daysSinceBackup, setDaysSinceBackup] = useState(0);

    useEffect(() => {
        const checkLastBackup = async () => {
            try {
                const lastSavedSetting = await db.settings.where('name').equals('LastSaved').first();
                
                if (!lastSavedSetting || !lastSavedSetting.data) {
                    // Aucune sauvegarde trouvée, afficher l'alerte
                    setShouldShowAlert(true);
                    setDaysSinceBackup(999); // Valeur indicative pour "jamais sauvegardé"
                    return;
                }

                const lastSavedDate = lastSavedSetting.data;
                
                // Parser la date AAAAMMJJ
                const year = parseInt(lastSavedDate.substring(0, 4));
                const month = parseInt(lastSavedDate.substring(4, 6)) - 1; // Mois commence à 0
                const day = parseInt(lastSavedDate.substring(6, 8));
                
                const lastBackupDate = new Date(year, month, day);
                const today = new Date();
                
                // Calculer la différence en jours
                const timeDiff = today.getTime() - lastBackupDate.getTime();
                const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
                
                setDaysSinceBackup(daysDiff);
                setShouldShowAlert(daysDiff > 7);
                
            } catch (error) {
                console.error('Erreur lors de la vérification de la dernière sauvegarde:', error);
                // En cas d'erreur, afficher l'alerte par sécurité
                setShouldShowAlert(true);
            }
        };

        checkLastBackup();
    }, []);

    return { shouldShowAlert, daysSinceBackup };
};

export default useBackupAlert;
